/*
 * InSight Analytics Solutions Limited
 * https://fieldpro.onyxinsight.com/
 *
 * Copyright (c) 2021 Onyx InSight Field Pro.
 * This file is licensed to InSight Analytics Solutions Limited
 */
const initialState = {
  issuepunchlist: '',
  addcustomerresult: null,
  customereditresult: null,
  isReload: false,
  issuePunchListColumn: null,
  resetSearch: null,
  checkSearch: false,
  indicator: false,
};

const issuepunchlistReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case 'issuepunchlist':
      return {
        ...state,
        issuepunchlist: action.value,
      };
    case 'addcustomer':
      return {
        ...state,
        addcustomerresult: action.value,
        isReload: true,
      };
    case 'customereditdata':
      return {
        ...state,
        customereditresult: action.value,
        isReload: true,
      };
    case 'validmail':
      return {
        ...state,
        isEmailValid: action.value,
      };
    case 'ISSUE_PUNCH_LIST_COLUMN':
      return {
        ...state,
        issuePunchListColumn: action.value,
      };
    case 'RESET_SEARCH':
      return {
        ...state,
        resetSearch: action.value,
      };
    case 'CHECK_SEARCH':
      return {
        ...state,
        checkSearch: action.value,
      };
    case 'INDICATOR':
      return {
        ...state,
        indicator: action.value,
      };
    default:
      return state;
  }
};

export default issuepunchlistReducer;
